import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const secondary: CSSProperties = {
    color: theme.text.secondary,
  };

  const styles: Record<string, CSSProperties> = {
    icon: {
      marginRight: spacing.m,
      flexShrink: 0,
      alignSelf: "flex-start",
      marginTop: spacing.xs,
    },
    card: {
      backgroundColor: theme.disclaimer.ssn.background,
      borderRadius: constants.radius.view,
      paddingLeft: spacing.m,
      paddingRight: spacing.m,
      paddingTop: spacing.l,
      paddingBottom: spacing.l,
    },
    header: {
      alignItems: "center",
    },
    title: {
      marginLeft: spacing.xs,
      marginBottom: 0,
      marginTop: 0,
    },
    subtitle: {
      fontSize: 12,
      lineHeight: "18px",
      fontWeight: 500,
      ...secondary,
    },
    badges: {
      display: "flex",
      flexDirection: "row",
      gap: spacing.xs,
    },
    badge: {
      flex: 1,
      backgroundColor: theme.background,
      borderRadius: constants.radius.view,
      paddingTop: spacing.s,
      paddingBottom: spacing.s,
      paddingLeft: spacing.xs,
      paddingRight: spacing.xs,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    badgeLabel: {
      textAlign: "center",
      fontSize: 11,
      lineHeight: "15px",
      color: theme.text.default,
    },
    bulletItem: {
      display: "flex",
      flexDirection: "row",
      paddingLeft: spacing.m,
    },
    bullet: {
      marginRight: spacing.xs,
    },
    legalText: {
      fontSize: 12,
      lineHeight: "18px",
      ...secondary,
    },
  };

  return styles;
};
